const selectors = {
  body: 'body',
  header: '.header',
  moveBackBtn: '.header__action-move-back-btn',
  mainContent: '.main-content',
  footer: '.footer',
  termsLink: '.js-terms',
};

export default selectors;
